import { render, staticRenderFns } from "./questionTypeCheckbox.vue?vue&type=template&id=36349408&scoped=true&"
import script from "./questionTypeCheckbox.vue?vue&type=script&lang=js&"
export * from "./questionTypeCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeCheckbox.vue?vue&type=style&index=0&id=36349408&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36349408",
  null
  
)

export default component.exports